// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { getArticlesListResponseTransformer } from './transformers.gen';
import type { GetArticlesListData, GetArticlesListResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Получение списка статей и достопримечательностей
 */
export const getArticlesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetArticlesListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetArticlesListResponses, unknown, ThrowOnError>({
    responseTransformer: getArticlesListResponseTransformer,
    url: '/service/journal/api/v1/articles',
    ...options,
  });
